import { Phone, AlertTriangle } from 'lucide-react';
import { trackPhoneCall } from '@/utils/analytics';

export default function EmergencyCTA() {
  return (
    <section data-testid="emergency-cta" className="relative bg-red-500 py-10 overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-1.5 hazard-stripe" />

      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <AlertTriangle className="w-10 h-10 text-white flex-shrink-0" />
          <div>
            <h3 className="font-heading text-xl md:text-2xl font-black text-white uppercase tracking-tight">
              Emergency? Tight Deadline? Need a Quote Fast?
            </h3>
            <p className="font-body text-sm text-white/80 mt-1">
              Call now. Speak directly with a real licensed electrician &mdash; no sales reps.
            </p>
          </div>
        </div>

        <a
          href="tel:+16159615930"
          data-testid="emergency-phone-btn"
          onClick={() => trackPhoneCall('emergency')}
          className="inline-flex items-center gap-3 bg-white text-red-600 font-heading font-black text-base px-8 py-4 hover:-translate-y-1 transition-transform flex-shrink-0 pulse-glow"
        >
          <Phone className="w-5 h-5" />
          (615) 961-5930
        </a>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-1.5 hazard-stripe" />
    </section>
  );
}
